import { useState, useEffect } from 'react';

export default (images: Record<string, string>) => {
  (window as Application).IMAGES ??= {};
  const { length } = Object.keys(images);

  const [loaded, setLoaded] = useState(false);
  const appImages = (window as Application).IMAGES;

  const [loadedImages, setLoadedImages] = useState(0);
  const onLoad = () => setLoadedImages((state) => state + 1);

  const preloadImage = (path: string) => {
    const image = new Image();
    appImages[path] = image;
    image.onload = onLoad;
    image.src = path;
  };

  useEffect(
    () => Object.values(images).forEach((image) => preloadImage(image)),
    []
  );

  useEffect(
    // React.StrictMode will double "loadedImages" count:
    () => setLoaded(!!length && length <= loadedImages),
    [images, loadedImages]
  );

  return loaded;
};
